import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, comparisonRows } from '../data/landing';
import { CountdownTimer } from './CountdownTimer';
const trustSignals = [{
  icon: LockKeyholeIcon,
  label: 'Secure payment'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function FinalCTA() {
  return <section className="border-y-4 border-gold bg-ink px-5 py-20" data-id="element-38" data-mp="m3dry967zvju">
      <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="h6nabherorwb">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-40" data-mp="h4153ofcmoh9">
          Stop improvising.{' '}
          <span className="text-gold" data-id="element-41" data-mp="qv5abwf82uyw">Start coaching with a system.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-42" data-mp="14v6izy1qb6ox">
          Join hundreds of tennis coaches worldwide who already plan their entire
          season in under 5 minutes.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-gold-light" data-id="element-43" data-mp="2c5g8ebwkrcyl">
          Sessions · Drills · Progressions · Assessment · All organized
        </p>
        <div className="mt-10 overflow-hidden border border-gold/30 text-left" data-id="element-44" data-mp="2m3416wameae4">
          <div className="grid grid-cols-2 bg-ink-mid text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-45" data-mp="2m5724bdb9nxm">
            <p className="p-4 text-slate-300" data-id="element-46" data-mp="2v3sfzt7u8es2">Without TENNIS READY™</p>
            <p className="border-l border-gold/30 p-4 text-gold" data-id="element-47" data-mp="2v1g2bs944qkt">
              With TENNIS READY™
            </p>
          </div>
          {comparisonRows.map(({
          without,
          withSystem
        }) => <div key={without} className="grid grid-cols-2 border-t border-gold/20 text-xs sm:text-sm" data-id="element-48" data-mp="34u3u28l8k4co">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-49" data-mp="3es1iaw33i15a">
                <span className="text-red-400" aria-hidden="true" data-id="element-50" data-mp="3epova4ihd0ld">
                  ×
                </span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-gold/20 bg-gold/5 p-4 font-semibold text-white" data-id="element-51" data-mp="1jp4tzpvaoznc">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-gold" data-id="element-52" data-mp="1eqjwhy7fgu2l" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-53" data-mp="1npf0d3n01s2q">
          <CountdownTimer dark data-id="element-54" data-mp="1np597cq7xevg" />
        </div>
        <div className="border-2 border-gold bg-ink-mid p-7 text-left" data-id="element-55" data-mp="22euoscz25lf9">
          <p className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-56" data-mp="22d03uynsdtb6">
            Complete package
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-57" data-mp="2bfj2t7ogbls5">
            TENNIS READY™ — 6 Volumes + 5 Bonuses
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-58" data-mp="27dee8ncv1fcd">
            <div data-id="element-59" data-mp="27c38ihzutxim">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-60" data-mp="h18d6x018nlb">
                $90
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-61" data-mp="d0essdlstqx6">
                $27
              </p>
            </div>
            <p className="bg-gold px-3 py-2 text-xs font-bold uppercase text-ink" data-id="element-62" data-mp="2wrlmqqu99e5">
              Save $63
            </p>
          </div>
        </div>
        <a href={CHECKOUT_URL} className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-63" data-mp="3pc2kb23ymzvl">
          YES, I WANT MY COACHING BIBLE
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-64" data-mp="3fcv6yex8758h">
          {trustSignals.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex gap-1" data-id="element-65" data-mp="36com27z772za">
              <Icon className="h-4 w-4 text-gold" data-id="element-66" data-mp="36dzy0v2srh1h" /> {label}
            </span>)}
        </div>
      </div>
    </section>;
}